import React from 'react';
import styles from './_style.module.scss';
import LoadingSpinner from '../../shared/LoadingSpinner';
import ImageCarousel from '../../shared/ImageCarousel';

const QuoteBuilderLayout = ({ images, loading, children }) => {
  return (
    <div className={styles.layoutContainer} data-widget-element="layout-container">
      {loading ? (
        <LoadingSpinner textColor="#94a3b8" />
      ) : (
        <>
          <div className={styles.imageColumn} data-widget-element="image-column">
            <ImageCarousel images={images} imageClassName={styles.previewImage} />
          </div>
          <div className={styles.formColumn} data-widget-element="form-column">
            <div className={styles.header} data-widget-element="header">
              <h3 className={styles.title} data-widget-element="title">{t('quote_builder_widget.get_a_quote')}</h3>
            </div>
            <div className={styles.formSection} data-widget-element="form-section">
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuoteBuilderLayout;
